/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.list-sort\":\"Vertical list with sorting arrow\"}");